import React, { useState, useEffect } from "react";
import { RouteComponentProps } from "react-router-dom";
import { callApi } from "bodycodi/cmap/app/js/common";
import gcld from "bodycodi/cmap/app/img/gcld.png";

const GcldSucces: React.FunctionComponent<RouteComponentProps> = ({ location }) => {
  const searchParams = new URLSearchParams(location.search);
  const code = searchParams.get("code");
  const state = searchParams.get("state");
  const error = searchParams.get("error");
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    if (code) {
      callApi("/calendars/sync", { code: code, seqMobileMembers: state }, "POST").then((res) => {
        if (res.MsgVO?.msgCd === "G00002") {
          setIsError(true);
        }
      });
    }
  }, []);

  if (error || isError) {
    return (
      <div className="gcld-wrap">
        <div className="gcld-body">
          <img src={gcld} className="icon" />
          <div className="bold">
            구글 캘린더 연동시
            <br />
            오류가 발생했습니다.
          </div>
          <div className="regular">다시 진행해주세요.</div>
        </div>
      </div>
    );
  }

  return (
    <div className="gcld-wrap">
      <div className="gcld-body">
        <img src={gcld} className="icon" />
        <div className="bold">
          구글 캘린더와
          <br />
          연동 완료되었어요
        </div>
        <div className="regular">
          바디코디 강사앱을 다시 실행하여
          <br />
          스케줄을 관리해보세요!
        </div>
      </div>
    </div>
  );
};

export default GcldSucces;
